module.exports = __webpack_public_path__ + "img/fant-farm-05.866d9dc9.jpg";